var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('base-back-to-previous-button',{staticClass:"mb-4"}),_c('CardProfile',{staticClass:"mb-4",attrs:{"user":_vm.user,"editable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }